import React from 'react';
import { type AhaEditorFieldV2Props } from './AhaEditorFieldV2';
import SuspenseWrapper from 'javascripts/SuspenseWrapper';

const LazyAhaEditorFieldV2 = React.lazy(
  () => import(/* webpackChunkName: "aha-editor-v2" */ './AhaEditorFieldV2')
);

interface LazyProps extends AhaEditorFieldV2Props {
  fallback?: React.ReactNode;
}
/**
 * @param {any} param0
 */
export const AhaEditorFieldV2 = ({
  fallback,

  ...props
}: LazyProps) => {
  return (
    <SuspenseWrapper fallback={fallback}>
      <LazyAhaEditorFieldV2 {...props} />
    </SuspenseWrapper>
  );
};
